const fallbackStats = [
  { value: "Live", label: "markets open by UTC window" },
  { value: "Public", label: "momentum every wallet can see" },
  { value: "3%", label: "creator share on every vote" }
];

export function formatHeroStatNumber(value) {
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue) || numericValue <= 0) {
    return "0";
  }

  if (numericValue >= 1000) {
    return `${trimTrailingZeroes(numericValue / 1000, 1)}K`;
  }

  return trimTrailingZeroes(numericValue, 2);
}

export function buildHomeHeroStats({ activeMarkets = [], upcomingMarkets = [], leaderboards = {} } = {}) {
  const liveCount = Array.isArray(activeMarkets) ? activeMarkets.length : 0;
  const queuedCount = Array.isArray(upcomingMarkets) ? upcomingMarkets.length : 0;
  const topVotes = Number(leaderboards?.global?.[0]?.votes || 0);

  if (liveCount === 0 && queuedCount === 0 && (!Number.isFinite(topVotes) || topVotes <= 0)) {
    return fallbackStats;
  }

  return [
    { value: `${liveCount} live`, label: `${queuedCount} queued next` },
    topVotes > 0
      ? { value: `${formatHeroStatNumber(topVotes)} SOL`, label: "top wallet moved" }
      : { value: "Public", label: "momentum every wallet can see" },
    { value: "3%", label: "creator share on every vote" }
  ];
}

export function getHomePulseOptions(market) {
  if (!Array.isArray(market?.options)) {
    return [];
  }

  return market.options.slice(0, 4).map((option, index) => ({
    id: option.id || `option-${index}`,
    label: option.label || `Option ${index + 1}`,
    percentage: toFiniteNumber(option.percentage),
    votes: toFiniteNumber(option.votes),
    totalVoteUnits: option.totalVoteUnits ?? option.total_vote_units ?? null
  }));
}

function trimTrailingZeroes(value, fractionDigits) {
  return Number(value.toFixed(fractionDigits)).toString();
}

function toFiniteNumber(value) {
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : 0;
}
